import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import React from 'react';

interface NavCard {
  icon: React.ReactNode;
  title: string;
  description: string;
  route: string;
}

const navCardsBase: NavCard[] = [
  {
    icon: <img src="/icons/student-girl-1.svg" alt="" width="28" height="28" className="object-contain" />,
    title: 'Ученики',
    description: 'Добавление и просмотр учеников',
    route: '/school/students',
  },
  {
    icon: <img src="/icons/course.png" alt="" width="28" height="28" className="object-contain" />,
    title: 'Курсы',
    description: 'Группы и учебные программы',
    route: '/school/courses',
  },
  {
    icon: <img src="/icons/Lesson-1.png" alt="" width="28" height="28" className="object-contain" />,
    title: 'Занятия',
    description: 'Расписание и проведение занятий',
    route: '/school/lessons',
  },
  {
    icon: <img src="/icons/payments.svg" alt="" width="28" height="28" className="object-contain" />,
    title: 'Платежи',
    description: 'История и учёт оплат',
    route: '/school/payments',
  },
  {
    icon: <img src="/icons/достижения.svg" alt="" width="28" height="28" className="object-contain" />,
    title: 'Достижения',
    description: 'Награды и достижения учеников',
    route: '/school/achievements',
  },
  {
    icon: <img src="/icons/archive.svg" alt="" width="28" height="28" className="object-contain" />,
    title: 'Архив',
    description: 'Архивированные ученики, курсы и группы',
    route: '/school/archive',
  },
];

export default function SchoolPage() {
  const navigate = useNavigate();
  const { permissions } = useAuth();

  const navCards: NavCard[] = [
    // Команду ведут владелец школы и админ школы; учитель в команде видит её
    // только для чтения (ЭТАП 8).
    ...(permissions.canViewSchoolTeam
      ? [{
          icon: <img src="/icons/team(school-page).svg" alt="" width="28" height="28" className="object-contain" />,
          title: 'Команда',
          description: permissions.canManageSchoolTeam
            ? 'Участники, роли, приглашения и уроки учителей'
            : 'Состав команды школы',
          route: '/school/team',
        }]
      : []),
    // Архив доступен только тем, кто может архивировать/восстанавливать
    ...(permissions.canArchiveStudents || permissions.canManageCourses || permissions.canManageGroups
      ? [{
          icon: <img src="/icons/archive.svg" alt="" width="28" height="28" className="object-contain" />,
          title: 'Архив',
          description: 'Архивированные ученики, курсы и группы',
          route: '/school/archive',
        }]
      : []),
    ...navCardsBase.filter(c => c.route !== '/school/archive'),
  ];

  return (
    <div className="p-4 space-y-3 animate-fade-in">
      <div className="mb-2">
        <h1 className="text-2xl font-bold text-[var(--tg-theme-text-color)]">
          <img src="/icons/school-1.svg" alt="" width="28" height="28" className="inline-block align-middle mr-2 object-contain" />
          Школа
        </h1>
        <p className="text-xs text-[var(--tg-theme-hint-color)] mt-0.5">
          Управление учебным процессом
        </p>
      </div>

      {navCards.map((card) => (
        <button
          key={card.route}
          onClick={() => navigate(card.route)}
          className="w-full tg-card flex items-center gap-4 p-4 text-left hover:shadow-md transition-all duration-200 active:scale-[0.98] group"
        >
          <div className="w-12 h-12 rounded-2xl bg-[var(--tg-theme-secondary-bg-color)] flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform">
            {card.icon}
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-base font-semibold text-[var(--tg-theme-text-color)] block">
              {card.title}
            </span>
            <span className="text-xs text-[var(--tg-theme-hint-color)] mt-0.5 block">
              {card.description}
            </span>
          </div>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-[var(--tg-theme-hint-color)] shrink-0 group-hover:translate-x-0.5 transition-transform"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      ))}
    </div>
  );
}
